import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';


import {makeLogger} from '../../../../logger/logger';
import type {ISearchersStrategyService} from '../../SearcherNamesStrategyService';
import type {SearchersData} from '../../types/searchers-data.type';
import {SearcherNamesStrategyService} from './searcher-names.service';

const {err} = makeLogger({pathToCurrentFile: 'components/strategies/services/searcher-names-service/searchers-fallback.service.ts'});



@Service({id: 'searcherNamesFallbackStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<ISearchersStrategyService> {

  build(details: SearchersData): ISearchersStrategyService {
      return new SearcherNamesStrategyFallback(details);
  }
}

export class SearcherNamesStrategyFallback extends SearcherNamesStrategyService {
  details;

  constructor(details: SearchersData) {
      super(details);
      this.details = details;
  }

  mapSearchersToDashboard(): any {//eslint-disable-line @typescript-eslint/no-explicit-any
      err(
        'The strategy does not have the correct searchers or application name'
      );
  }

}
